var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partnership-flow"},[_c(_vm.getPartnerComponent(),{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }